import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#4c2779",
        violet: "#7460ee",
        secondary: "#b0bec5",
        accent: "#8c9eff",
        error: "#b71c1c",
        white: "#fff",
        darkGrey: "#607d8b",
        grey: "#e8e8e8"
      },
    },
  },
});
